// extracted by mini-css-extract-plugin
export var createdDate = "_fj-1";
export var divider = "_fj-2";
export var headerDivider = "_fj-3";
export var messagesCard = "_fj-0";
export var messagesContainer = "_fj-6";
export var messagesContainerWrapper = "_fj-4";
export var showLeftPanelButton = "_fj-8";
export var topButtons = "_fj-7";
export var withPadding = "_fj-5";